import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import HomePage from "./pages/home/index";

import "./App.scss";
import { Provider } from "react-redux";
import store from "./redux/store";

export default function App() {
  return (
    <Router>
      <Switch>
        <Provider store={store}>
          <Route exact path="/" component={HomePage}></Route>
        </Provider>
      </Switch>
    </Router>
  );
}
